import React from 'react';

/**
 * Logo LadderPVP : cases du damier de combat empilées
 * (vertes = déplacement, pourpres = sort).
 */
const Logo = ({ size = 180 }) => (
    <svg
        width={size}
        height={Math.round(size * 110 / 180)}
        viewBox="0 0 180 110"
        fill="none"
        strokeWidth="1.5"
        role="img"
        aria-label="LadderPVP"
    >
        <path d="M90 10l30 15-30 15-30-15z" fill="rgba(124,203,91,0.25)" stroke="#7CCB5B" />
        <path d="M60 25l30 15-30 15-30-15z" fill="rgba(124,203,91,0.12)" stroke="#5A8F45" />
        <path d="M120 25l30 15-30 15-30-15z" fill="rgba(124,203,91,0.12)" stroke="#5A8F45" />
        <path d="M90 40l30 15-30 15-30-15z" fill="#7CCB5B" stroke="#A8E58C" />
        <path d="M60 55l30 15-30 15-30-15z" fill="rgba(155,107,255,0.14)" stroke="#6E4FBF" />
        <path d="M120 55l30 15-30 15-30-15z" fill="rgba(155,107,255,0.14)" stroke="#6E4FBF" />
        <path d="M90 70l30 15-30 15-30-15z" fill="#9B6BFF" stroke="#CDB4FF" />
    </svg>
);

export default Logo;
